import {
  clearComponentInterval,
  clearComponentTimer,
  clearComponentTimers,
  scheduleComponentInterval,
  scheduleComponentTimer,
} from 'dashboard/helper/timerLifecycle';

export default {
  methods: {
    scheduleTimer(callback, delay) {
      return scheduleComponentTimer(this, callback, delay);
    },
    clearScheduledTimer(timer) {
      clearComponentTimer(this, timer);
    },
    scheduleInterval(callback, delay) {
      return scheduleComponentInterval(this, callback, delay);
    },
    clearScheduledInterval(interval) {
      clearComponentInterval(this, interval);
    },
    clearScheduledTimers() {
      clearComponentTimers(this);
    },
  },
};
